export default __webpack_public_path__ + "static/media/illo.walkies.pro.43aca161.png";